import { analytics } from '../analytics';
import { CASE_IMPORT_EVENT_IDS } from '../events';
import { generateRandomIPAddress } from '../utils';

export interface TrackCaseImportHistoryViewedProps {
  organisation_id: number;
  user_id: string;
  user_system_role?: string[] | null;
  has_active_import: boolean;
}

export interface TrackCaseImportHistoryReportOpenedProps {
  organisation_id: number;
  user_id: string;
  job_id: string;
  file_name: string;
  import_status: string;
}

export interface TrackCaseImportEnteredProps {
  organisation_id: number;
  user_id: string;
  user_system_role?: string | null;
  entry_point: 'nav_import_cases' | 'cases_add_multiple';
}

export interface TrackCaseImportReviewOpenedProps {
  organisation_id: number;
  user_id: string;
  file_name: string;
  total_rows: number;
  rows_ready_to_import: number;
  rows_dropped_duplicates: number;
}

export interface TrackCaseImportConfirmedProps {
  organisation_id: number;
  user_id: string;
  file_name: string;
  total_rows: number;
  rows_ready_to_import: number;
  rows_dropped_duplicates: number;
}

export interface TrackCaseImportCancelledProps {
  organisation_id: number;
  user_id: string;
  file_name: string;
  total_rows: number;
  rows_ready_to_import: number;
  rows_dropped_duplicates: number;
}

export const trackCaseImportHistoryViewedEvent = (
  properties: TrackCaseImportHistoryViewedProps,
) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_HISTORY_VIEWED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportEnteredEvent = (
  properties: TrackCaseImportEnteredProps,
) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_ENTERED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportHistoryReportOpenedEvent = (
  properties: TrackCaseImportHistoryReportOpenedProps,
) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_HISTORY_REPORT_OPENED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportReviewStartedEvent = (properties: {
  organisation_id: number;
  user_id: string;
  user_system_role: string | null;
  is_default_questions_flow?: boolean;
  is_dynamic_questions_flow?: boolean;
}) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_REVIEW_STARTED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportCsvValidationFailedEvent = (properties: {
  organisation_id: number;
  user_id: string;
  user_system_role: string | null;
}) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_CSV_VALIDATION_FAILED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportProcessingFailedToStart = (properties: {
  organisation_id: number;
  user_id: string;
  user_system_role: string | null;
}) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_PROCESSING_FAILED_TO_START,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportReviewOpened = (
  properties: TrackCaseImportReviewOpenedProps,
) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_REVIEW_OPENED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportConfirmed = (
  properties: TrackCaseImportConfirmedProps,
) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_CONFIRMED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportCancelled = (
  properties: TrackCaseImportCancelledProps,
) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_CANCELLED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackCaseImportFlowExited = (properties: {
  organisation_id: number;
  user_id: string;
  step_where_exited: string;
}) => {
  return analytics.track(
    CASE_IMPORT_EVENT_IDS.CASE_IMPORT_FLOW_EXITED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};
